import Vue from 'vue'

Vue.mixin({
  methods: {
    showModal: function(modalRefName, preserveInputValues) {
      if (this.$refs && this.$refs[modalRefName]) {
        if (!preserveInputValues && this.$refs[modalRefName].$children) {
          for (let i = 0; i < this.$refs[modalRefName].$children.length; i++) {
            if (
              typeof this.$refs[modalRefName].$children[i].initiateValue ===
              'function'
            ) {
              this.$refs[modalRefName].$children[i].initiateValue()
            }
          }
        }
        this.vibrate()
        this.$refs[modalRefName].show()
        this.$nextTick(() => {
          this.$forceUpdate()
          window._eventHub.$emit('hideLoading')
        })
      } else {
        window._eventHub.$emit('hideLoading')
      }
    },
    hideModal: function(modalRefName) {
      if (this.$refs && this.$refs[modalRefName]) {
        this.$refs[modalRefName].hide()
      }
    }
  }
})
